import type { RouteObject } from "react-router-dom";
import { useLocale } from "@admin/app/locale";
import { AreasPage } from "./pages/AreasPage";
import { AreaSuggestionsPage } from "./pages/AreaSuggestionsPage";

function AreasRoute() {
  const locale = useLocale();
  return <AreasPage locale={locale} />;
}

function AreaSuggestionsRoute() {
  const locale = useLocale();
  return <AreaSuggestionsPage locale={locale} />;
}

export const areaRoutes: RouteObject[] = [
  {
    path: "areas",
    element: <AreasRoute />,
  },
  {
    path: "area-suggestions",
    element: <AreaSuggestionsRoute />,
  },
];
